export const initialValues = {
    selectedMedications: [],
    isPregnat: null,
    additionalDiseases: null,
    additionalDiseasesDescription: null,
    hasCare: null,
    carePerson: null,
    hasOperations: null,
    operationsDescription: null,
    operationsYears: null,
    hasOperationComplications: null,
    drugWasUsed: null,
    hasDrugAllergies: null,
    whatDrugsHasAllergies: '',
    importantInformation: '',
    uploadedFile: null,
    agreement: false,
    personalInformation: {
        name: '',
        surname: '',
        email: '',
        phone: '',
        address: '',
        houseNumber: '',
        city: '',
        zipCode: '',
        pesel: '',
    },
};
